var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFabrics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.09091H4C3.73478 5.09091 3.48043 5.19627 3.29289 5.38381C3.10536 5.57134 3 5.8257 3 6.09091V20.0909C3 20.3561 3.10536 20.6105 3.29289 20.798C3.48043 20.9856 3.73478 21.0909 4 21.0909H20C20.2652 21.0909 20.5196 20.9856 20.7071 20.798C20.8946 20.6105 21 20.3561 21 20.0909V6.09091C21 5.8257 20.8946 5.57134 20.7071 5.38381C20.5196 5.19627 20.2652 5.09091 20 5.09091H18M6 5.09091L8 3.09091M6 5.09091L8 10.0909L12 7.38091M8 3.09091H16M8 3.09091L12 7.38091M16 3.09091L18 5.09091M16 3.09091L12 7.38091M18 5.09091L16 10.0909L12 7.38091",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFabrics);
export default __webpack_public_path__ + "static/media/icon_fabrics.ffda82709ee34ec86f522f92708c91a5.svg";
export { ForwardRef as ReactComponent };